import { LeadMagnetFormProfile } from '../../slices/leadMagnetForm';

export type LeadMagnetFormFetcherArguments = {
  'email': string;
  'leadMagnetId': number;
  'nombre': string;
  'telefono': string;
  'recaptcha-token': string;
  'regionId'?: number;
  'communeId'?: number;
  'acceptNewsletter'?: '1';
  'empresa'?: string;
  'profile'?: LeadMagnetFormProfile;
};

export default function leadMagnetFormFetcher(
  values: LeadMagnetFormFetcherArguments
) {
  const query = new URLSearchParams({
    pais: process.env.NEXT_PUBLIC_COUNTRY
  });

  const body = new FormData();

  for (const key in values) {
    let value = values[key as keyof LeadMagnetFormFetcherArguments];

    if (value) {
      if (typeof value === 'number') {
        value = value.toString();
      }

      body.append(key, value);
    }
  }

  body.append('ajax_request', 'informe_pt');

  return fetch(
    `${process.env.NEXT_PUBLIC_LEGACY_HOST}/get_ajax_data.php?${query}`,
    {
      method: 'POST',
      body
    }
  );
}
